module.exports = __webpack_public_path__ + "static/ddtsi-logo-tagline-2023f3674d0563c2ab9fb0e20c0f1f1c.svg";